<template>
  <div class="flex w-full flex-col gap-4">
    <h2 class="text-sm lg:text-4xl font-bold text-blue">{{ agency.Name }}</h2>
    <span class="mb-4 font-bold text-grey-80">
            Branch: <span class="font-normal">{{ branch.town }}</span>
        </span>
    <HorizontalSeparator class="mb-4"/>

    <template v-if="!fetching">
      <template v-if="!error">
        <h3 class="mb-2 text-sm lg:text-xl font-bold text-red-450">
          Sorry! The agency hasn’t provided this contact detail. Please select one of the other available options.
        </h3>

        <div class="flex w-full flex-col gap-4 lg:w-3/12">
          <InputButton v-if="hasEmail" style-type="contact-form" @click="chooseOption('email')">
            Email Agency<br/>
          </InputButton>
          <InputButton v-if="hasTelephone" style-type="contact-form" @click="chooseOption('telfax')">
            Display Phone Number<br/>
          </InputButton>
          <InputButton v-if="hasWebsite" style-type="contact-form" @click="chooseOption('website')">
            Visit Website<br/>
          </InputButton>
        </div>
      </template>
      <div v-else>
        <h3 class="mb-2 text-xl">Sorry, something went wrong</h3>
        <p> {{ errorMessage }}</p>
      </div>
    </template>
    <div v-else>
      Loading contact information.
    </div>
  </div>
</template>

<script>
import HorizontalSeparator from 'Components/HorizontalSeparator';
import AcCard from 'Components/AcCard';
import InputButton from 'Components/InputButton';

export default {
  name: 'ChooseOtherContactOption',
  components: {InputButton, AcCard, HorizontalSeparator},
  data() {
    return {
      fetching: false,
      error: false,
      errorMessage: null
    };
  },
  props: {
    agency: {
      type: Object,
    },
    branch: {
      type: Object,
    },
    userType: {
      type: String,
    },
    hasWebsite: {
      type: Boolean
    },
    hasEmail: {
      type: Boolean
    },
    hasTelephone: {
      type: Boolean
    },
  },
  emits: ['selectOtherOption', 'closeClick'],
  methods: {
    chooseOption(method) {
      this.$emit('selectOtherOption', {method});
    },
  },
  mounted() {

  },
};
</script>
